import { Link, useSearch } from '@tanstack/router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import useGameCategories from '../../hooks/useGameCategories'
import { useBoundStore } from '../../store/store'
import type { CasinoCategory } from '../../store/types/casino'
import type { CasinoSearch } from '../../types/route-search'
import classNames from '../../utils/classNames'
import GameCategoryIcon from '../casino/game-category-icon'
import Icon from '../icon'

type CasinoDrawerTabsProps = {
  closeProfileDrawer: () => void
}

const CasinoDrawerTabs = ({ closeProfileDrawer }: CasinoDrawerTabsProps) => {
  const { category: categoryParam } = useSearch<
    '/casino',
    true,
    CasinoSearch,
    CasinoSearch
  >()
  const { categories } = useGameCategories()
  const theme = useBoundStore(state => state.common.theme)
  const { t } = useTranslation('drawer')
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className="transition-all duration-[0.2s] ease-[ease-in-out] overflow-hidden"
      style={{
        height: isOpen ? categories.length * 40.99 + 55 : '45px',
      }}>
      <div
        className="flx-btw-ctr px-5 py-2.5"
        onClick={() => setIsOpen(prev => (prev ? false : true))}>
        <div className="flx-str-ctr">
          <div className="flx-str-ctr" style={{ width: '40px' }}>
            <Icon
              className="transition-all duration-[0.2s] ease-[ease-in-out]"
              id="casino"
              width="25"
              height="25"
            />
          </div>
          <span className="text-xs font-Syncopate-Bold uppercase text-txt">
            {t('casino')}
          </span>
        </div>
        <Icon
          className="transition-all duration-[0.2s] ease-[ease-in-out]"
          id="triangle-left"
          width="10"
          height="21"
          fill="#DF0033"
          style={{ transform: `rotate(${isOpen ? '-90' : '0'}deg)` }}
        />
      </div>
      <div style={{ padding: '0 0 0 60px' }}>
        {!categories.length
          ? Array.from({ length: 17 }, (_, index) => (
              <div
                className={classNames(
                  'flx-str-ctr gap-[15px] px-0 py-2 last:border-0 animate-pulse',
                )}
                key={index}>
                <div className="bg-secondary-txt-20 block w-[25px] aspect-square rounded-[5px]" />
                <p className="w-[100px] h-[11px] bg-secondary-txt-20 rounded-[3px]" />
              </div>
            ))
          : categories?.map((category: CasinoCategory) => (
              <Link
                to="/casino/$category"
                params={{
                  category: category.category.toLowerCase().replace(' ', '-'),
                }}
                key={category.id}>
                <div
                  className={classNames(
                    'flx-str-ctr gap-[15px] px-0 py-2 last:border-0',
                  )}
                  onClick={closeProfileDrawer}>
                  <GameCategoryIcon
                    {...category}
                    className={
                      categoryParam === category.id ? 'fill-[#df0033]' : ''
                    }
                    isActive={categoryParam === category.id}
                    theme={theme}
                    size={25}
                  />
                  <span className="text-xs font-Syncopate-Bold uppercase text-txt">
                    {category.category}
                  </span>
                </div>
              </Link>
            ))}
      </div>
    </div>
  )
}

export default CasinoDrawerTabs
